import { MonthTemperature } from "./../../../Models/ServerModels/Shared/MonthTemperature";
import { Api, LogService } from "../../../Services";
import { AppThunk } from "./../../Store";
import { Actions } from "./SolutionSlice";
import { SavedItemsRequest } from "../../../Models";
import { getSavedItemsRequest, getMulticoteCalculationRequest } from "../Solution/SolutionUtils";

export const getAllMulticoteBlends = (): AppThunk => async (dispatch: any) => {
  try {
    const multicoteBlends = await Api.Solution.getAllMulticoteBlends();

    if (multicoteBlends && multicoteBlends.statusCode === 200 && multicoteBlends.data) {
      dispatch(Actions.setMulticoteBlends(multicoteBlends.data as any));
    } else {
      LogService.logError(`get all raw materials data request had failed. Response: ${multicoteBlends}`);
    }
  } catch (ex) {
    LogService.logError(`Exception occurred in getAllRawMaterials: ${ex}`);
  }
};
//solution
export const calculateMulticoteSolutionsResult =
  (onSuccess?: () => void): AppThunk =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(Actions.setCalculateSolutionResultInProgress(true));
      const requestBody = getMulticoteCalculationRequest(getState);
      const response = await Api.Calculations.calculateMulticoteSolutionResults(requestBody);

      if (response && response.statusCode === 200 && response.data) {
        dispatch(Actions.setReleaseGraphValues(response.data.releaseGraphValues));
        await dispatch(Actions.setCurrentDayReleaseRemainValuesForMulticoteSolution(response.data.currentDayReleaseRemainValues));
        await dispatch(Actions.setItemId(response.data.savedItemId));
        dispatch(Actions.setCalculateSolutionResultInProgress(false));
        dispatch(Actions.setCalculateSolutionResultIsSuccess(true));
        onSuccess && onSuccess();
      } else {
        LogService.logError(`calculateMulticoteSolutionsResult request had failed. Response: ${response}`);
        dispatch(Actions.setCalculateSolutionResultInProgress(false));
        dispatch(Actions.setCalculateSolutionResultIsSuccess(false));
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in calculateMulticoteSolutionsResult: ${ex}`);
    }
  };
export const saveProcess = (): AppThunk => async (dispatch: any, getState: any) => {
  try {
    const request: SavedItemsRequest = getSavedItemsRequest(getState);
    const response = await Api.SavedItems.saveItem(request);
    if (response && response.statusCode === 200 && response.data) {
      await dispatch(Actions.setItemId(response.data.savedItemId));
    }
  } catch (ex) {
    LogService.logError(`Exception occurred in saveProcess: ${ex}`);
    throw ex;
  }
};
